// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_JwtStatus from "../Ouroboros.Models.Brands.JwtStatus/index.js";
import * as Ouroboros_Models_Brands_JwtSubscriptionStatus from "../Ouroboros.Models.Brands.JwtSubscriptionStatus/index.js";
import * as Ouroboros_Models_Brands_StripeUserKey from "../Ouroboros.Models.Brands.StripeUserKey/index.js";
import * as Ouroboros_Models_Brands_SubscriptionStatus from "../Ouroboros.Models.Brands.SubscriptionStatus/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readFieldsCons = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "subscription_status";
    }
});
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(Ouroboros_Models_Brands_SubscriptionStatus.readSubscriptionStatus)(Simple_JSON.readFieldsNil)()()));
var readJson2 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_JwtStatus.readJwtStatus)(/* #__PURE__ */ readFieldsCons(Ouroboros_Models_Brands_JwtSubscriptionStatus.readJwtSubscriptionStatus)(Simple_JSON.readFieldsNil)()())()()));
var readJson3 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "payment_intent";
    }
})(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "stripe_user_key";
    }
})(Ouroboros_Models_Brands_StripeUserKey.readStripeUserKey)(Simple_JSON.readFieldsNil)()())()()));
var isSubscriptionStatus = function (value) {
    return value === "Paid" || (value === "PaymentFailed" || (value === "FreeTrialMode" || (value === "PaymentNotYetConfigured" || value === "Canceled")));
};
var isJwtSubscription = function (value) {
    return isSubscriptionStatus(value) || value === "not-found";
};
var isJwtStatus = function (value) {
    return value === "authorized" || value === "unauthorized";
};
var decodeSubscriptionStatusResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $44 = isSubscriptionStatus(Ouroboros_Models_Brands_SubscriptionStatus.unwrap(decoded.subscription_status));
        if ($44) {
            return new Data_Either.Right(decoded);
        };
        return new Data_Either.Left("Invalid subscription status payload");
    });
};
var decodeJwtResponse = function (value) {
    return bind(readJson2(value))(function (decoded) {
        var $45 = isJwtStatus(Ouroboros_Models_Brands_JwtStatus.unwrap(decoded.status)) && isJwtSubscription(Ouroboros_Models_Brands_JwtSubscriptionStatus.unwrap(decoded.subscription_status));
        if ($45) {
            return new Data_Either.Right(decoded);
        };
        return new Data_Either.Left("Invalid JWT response payload");
    });
};
var decodeCreateAccountResponse = function (value) {
    return readJson3(value);
};
export {
    decodeJwtResponse,
    decodeSubscriptionStatusResponse,
    decodeCreateAccountResponse
};
//# sourceMappingURL=index.js.map
